import React, { useState, useEffect } from 'react';
import { PDFDocument } from 'pdf-lib';

let DrawDocuSign = (props) => {
  const [fileUrl, setFileUrl] = useState(null);
  console.log(props)
  // Funkcja do załadowania pliku PDF z folderu public
  const fetchPDF = async () => {
    const pdfUrl = '/grenke-docusign.pdf';  // Ścieżka do pliku w folderze public
  
    try {
      const response = await fetch(pdfUrl);
      if (!response.ok) {
        throw new Error(`Błąd podczas pobierania pliku PDF: ${response.statusText}`);
      }
      const pdfBlob = await response.blob();
      console.log('PDF załadowany pomyślnie');
      return pdfBlob;
    } catch (error) {
      console.error('Błąd przy pobieraniu PDF:', error);
      throw new Error('Nie udało się pobrać pliku PDF');
    }
  };

  // Funkcja do edytowania PDF (dodanie tekstu i miejsca na podpis)
  const editPDF = async (pdfBlob) => {
    try {
      const existingPdfBytes = await pdfBlob.arrayBuffer();
      const pdfDoc = await PDFDocument.load(existingPdfBytes);
      console.log('Dokument PDF załadowany pomyślnie');
      
      // Dodajemy tekst na stronie PDF
      const page = pdfDoc.getPages()[0];
      //1
      page.drawText(props.companyName, { x: 310, y: 680, size: 12 }); 
      page.drawText(props.legalRepresentative, { x: 310, y: 650, size: 12 });
      page.drawText(props.companyAddress, { x: 310, y: 630, size: 12 });
      page.drawText(props.phone, { x: 310, y: 600, size: 12 });
      page.drawText(props.email, { x: 310, y: 580, size: 12 });
      page.drawText(props.trn, { x: 310, y: 560, size: 12 });
      //2
      page.drawText(props.shareCapital, { x: 310, y: 502, size: 12 });
      page.drawText(props.legalForm, { x: 310, y: 483, size: 12 });
      page.drawText(props.lineBusiness, { x: 310, y: 465, size: 12 });
      page.drawText(props.revenueLastFinancialYear, { x: 310, y: 446, size: 12 });
      page.drawText(props.revenuePresentFinancialYear, { x: 310, y: 426, size: 12 });
      page.drawText(props.employeesNumber, { x: 310, y: 408, size: 12 });
      page.drawText(props.financialAddress, { x: 310, y: 390, size: 12 });
      //3
      page.drawText(props.bankName, { x: 310, y: 315, size: 12 });
      page.drawText(props.bankIban, { x: 310, y: 293, size: 12 });
      page.drawText(props.bankEmail, { x: 310, y: 273, size: 12 });
      page.drawText(props.bankNumber, { x: 310, y: 253, size: 12 });
      console.log('Tekst dodany do dokumentu');
      
      // Zapisz zmodyfikowany PDF do nowego obiektu
      const modifiedPdfBytes = await pdfDoc.save();
      console.log('PDF zapisany');
      
      // Utwórz obiekt Blob
      const modifiedPdfBlob = new Blob([modifiedPdfBytes], { type: 'application/pdf' });
      console.log('Blob z zapisanym PDF utworzony');
      
      // Utwórz obiekt File, aby pasował do formatu, który używasz w formularzach
      const file = new File([modifiedPdfBlob], 'modified-document.pdf', { type: 'application/pdf' });
  
      return file;
    } catch (error) {
      console.error('Błąd podczas edytowania PDF:', error);
      alert('Błąd przy edytowaniu PDF');
      throw error;
    }
  };
  
  // Użycie tej funkcji w processDocument:
  const processDocument = async () => {
    try {
      const pdfBlob = await fetchPDF(); // Pobierz plik PDF
      const modifiedFile = await editPDF(pdfBlob); // Edytuj PDF, zwróci obiekt File
      console.log('Zmodyfikowany plik PDF', modifiedFile);
      
      // Przekaż zmodyfikowany plik do rodzica za pomocą props.setFile
      props.setFile(modifiedFile);
      
      // Utwórz URL do podglądu
      const fileUrl = URL.createObjectURL(modifiedFile);
      setFileUrl(fileUrl); // Ustaw URL do podglądu w iframe
    } catch (error) {
      console.error('Błąd przy edytowaniu PDF:', error);
      alert('Błąd przy edytowaniu PDF!');
    }
  };

  useEffect(() => {
    processDocument(); // Automatycznie przetwarzaj dokument po załadowaniu komponentu
  }, []);

  // Przekazanie fileUrl do props
  return ( 
    <div>
      {/* <h1>Edytor PDF z podpisem DocuSign</h1>

      {fileUrl && (
        <div>
          <h3>Podgląd zmodyfikowanego pliku PDF:</h3>
          Przekazujemy fileUrl jako props do innego komponentu
          <PreviewPDF fileUrl={fileUrl} />
        </div>
      )} */}
    </div>
  );
};

const PreviewPDF = ({ fileUrl }) => {
  return (
    <div>
      {/* <h3>Podgląd pliku PDF:</h3>
      <iframe src={fileUrl} width="600" height="400" title="Podgląd PDF"></iframe> */}
    </div>
  );
}

export default DrawDocuSign;
